import Resource from './Resource';

export default class GetBaciasResource extends Resource {
  async result() {
    try {
      const { data, status } = await this.request.get('/bacias');
      if (status === 200) {
        return data.reduce((total, item) => ({
          ...total,
          [item.id_bacia]: {
            name: item.nome,
          }
        }), {});
      }
    } catch (error) {
      console.log(error); //eslint-disable-line
    }
    return {};
  }
}
